export interface HttpErrorProps {
  message: string;
  method: string;
  path: string;
  statusCode: number;
  xRequestId: string | null;
}

export default class HttpError extends Error {
  message: string;
  method: string;
  path: string;
  stack?: string;
  status: number;
  statusCode: number;
  xRequestId: string | null;

  constructor({ message, statusCode, path, method, xRequestId }: HttpErrorProps) {
    super();
    this.name = 'HttpError';
    this.message = message;
    const p = path.split('?')[0];
    this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    this.method = method;
    this.status = statusCode;
    this.statusCode = statusCode;
    this.xRequestId = xRequestId;
    this.stack = new Error().stack;
  }
}
